export const GROUP_INTEGRATION_LIST_ITEM_TEST_ID = "group-integration-list-item";
